import PropTypes from 'prop-types';
import React from 'react'
import RadioGroup from 'react-radio-group'
import { filter } from 'underscore'

import { Single as InterestBox } from './components'
import { toggleInterests } from '~/actions/interests'


export default class extends React.Component {
    static propTypes = {
		dispatch: PropTypes.oneOfType([
			PropTypes.func,
			PropTypes.bool
		]),
		interests: PropTypes.array.isRequired,
		userInterests: PropTypes.array.isRequired,
		changeInterest: PropTypes.func
	};

    state = {
        startingInterests: [],
        changedInterests: []
    };

    componentWillMount() {
		var newInterests = this.props.userInterests && this.props.userInterests.length > 0 
			? this.props.userInterests.map(function(a) {return a.ID;})
			: [];
 		this.setState({
			startingInterests: newInterests,
			changedInterests: newInterests
 		})

	}

    toggleInterest = (ID) => {

		if( this.props.overrideLink && !!this.props.history ) this.props.history.push( this.props.overrideLink)

		var newInterests = this.state.changedInterests,
			indexOfThis = newInterests.indexOf(ID);

		if( indexOfThis > -1) { 
			var toToggle = newInterests[indexOfThis]
			newInterests.splice(indexOfThis,1)
		} else {
			var toToggle = ID;
			newInterests = newInterests.concat([ID]);
		}

		this.setState({
			changedInterests: newInterests
		});

		this.props.dispatch( toggleInterests([toToggle]) )

		if(!!this.props.changeInterest) this.props.changeInterest(newInterests)

	};

    render() {

		let editable = !!this.props.dispatch,
			interestLoop = editable ? this.props.interests : this.props.userInterests;

		interestLoop = filter(interestLoop, {hidden: false})

		return (

			<div className="interestBoxGrid">
				{!!interestLoop &&
					interestLoop.map(interest => {
					return <InterestBox 
								{...interest} 
								editable={editable}
								key={interest.ID}
								clickAction={this.toggleInterest} 
								selected={this.state.changedInterests.indexOf(interest.ID) > -1} />
		        	})
				}
	        </div>

		)

	}
}



// WEBPACK FOOTER //
// ./src/js/components/Interests/Toggle.js